import { submitAnswer } from "lib/api/motibell/submitAnswer"
import { useMutation } from "@tanstack/react-query"

const useSubmitAnswerMutate = () => {
	return useMutation((payload) => submitAnswer(payload))
}

export default useSubmitAnswerMutate
